import { RichTextDisplay } from "@datagame/ui";
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { ChartHeader } from "../../ChartHeader";
import { ChartTooltip } from "../../ChartTooltip";

import styles from "../TriviaChart.module.scss";

export type TriviaChartData = {
  id: string;
  question: string;
  options: {
    text: string;
    count: number;
  }[];
};

export const Chart = ({ data }: { data: TriviaChartData }) => {
  return (
    <div className={styles.container}>
      <ChartHeader>
        <RichTextDisplay value={data.question} plain={true} />
      </ChartHeader>
      <ResponsiveContainer width="100%" height="100%" minHeight={400}>
        <BarChart
          layout="vertical"
          width={500}
          height={400}
          data={data.options}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <XAxis type="number" tickLine={false} orientation="top" allowDecimals={false} />
          <YAxis width={200} type="category" dataKey="text" tickLine={false} />

          <Tooltip content={<ChartTooltip translation="report:trivia.tooltip" />} cursor={{ fill: "#E8E8E8" }} />

          <Bar dataKey="count" fill="#F6A16F" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
